import { useLocation, useNavigate } from "react-router-dom";

import { BaseLandingPage } from "./BaseLandingPage/BaseLandingPage";
import { USPType } from "./BaseLandingPage/USP";

const profitIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="40"
    height="40"
    viewBox="0 0 24 25"
    fill="none"
  >
    <path
      d="M12 0C14.8751 0 19.3408 0.532647 19.3408 0.532647C19.3408 2.00351 20.5332 3.19588 22.004 3.19588H23V17.6597C23 19.0261 22.1908 20.2627 20.9387 20.8097L12 24.7148L3.06133 20.8097C1.80924 20.2627 1 19.0261 1 17.6597V3.19588H1.99597C3.46683 3.19588 4.6592 2.00351 4.6592 0.532647C4.6592 0.532647 9.12487 0 12 0Z"
      fill="currentColor"
    />
    <defs>
      <clipPath
        id="bgblur_0_3133_53580_clip_path"
        transform="translate(6.10101 7.10101)"
      >
        <path d="M12 0C14.8751 0 19.3408 0.532647 19.3408 0.532647C19.3408 2.00351 20.5332 3.19588 22.004 3.19588H23V17.6597C23 19.0261 22.1908 20.2627 20.9387 20.8097L12 24.7148L3.06133 20.8097C1.80924 20.2627 1 19.0261 1 17.6597V3.19588H1.99597C3.46683 3.19588 4.6592 2.00351 4.6592 0.532647C4.6592 0.532647 9.12487 0 12 0Z" />
      </clipPath>
    </defs>
  </svg>
);

const coinIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="40"
    height="40"
    viewBox="0 0 28 24"
    fill="none"
  >
    <path
      d="M17.5 22.5C23.299 22.5 28 17.799 28 12C28 6.20101 23.299 1.5 17.5 1.5C17.2805 1.5 17.0625 1.50674 16.8464 1.52001C20.3855 3.66779 22.75 7.55776 22.75 12C22.75 16.4422 20.3855 20.3322 16.8464 22.48C17.0626 22.4933 17.2805 22.5 17.5 22.5Z"
      fill="#D4D8DE"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0 12C0 17.799 4.70101 22.5 10.5 22.5C11.7272 22.5 12.9053 22.2895 14 21.9025C18.0782 20.4611 21 16.5718 21 12C21 7.42824 18.0782 3.5389 14 2.09747C12.9053 1.71054 11.7272 1.5 10.5 1.5C4.70101 1.5 0 6.20101 0 12ZM5.42057 7.91638L1.54991 14.5518L2.69834 16.0831H7.12291L10.8943 9.61777L9.84513 7.91638L5.97447 14.5518H3.59157L7.46223 7.91638H5.42057ZM12.2261 7.91638L11.2336 9.61777H13.9559L10.1845 16.0831H12.2261L15.9975 9.61777L18.0392 9.61777L19.0317 7.91638H12.2261Z"
      fill="#D4D8DE"
    />
  </svg>
);

const playerIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="40"
    height="40"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M10.9361 12.3875C10.9361 12.3875 9.58718 10.1164 9.92348 7.93224C10.1543 6.43328 10.9799 5.1273 12.1325 4.2318C11.5983 2.22799 10.025 0.792128 7.89744 0.744355C5.51732 0.690913 3.70141 2.44151 3.34142 4.79485C3.06707 6.58835 4.96162 9.14914 4.96162 9.14914C1.33216 10.7723 0.131018 12.7583 -0.000244141 18.8703H6.74039C7.10741 15.5476 8.05952 13.9316 10.9361 12.3875Z"
      fill="#D9D9D9"
    />
    <path
      d="M8.30407 22.7171C8.43533 16.6051 9.63648 14.6191 13.2659 12.9959C13.2659 12.9959 11.3714 10.4351 11.6457 8.64164C12.0057 6.2883 13.8216 4.5377 16.2017 4.59114C18.5238 4.64328 20.1856 6.34885 20.5568 8.64164C20.8447 10.4194 19.0379 12.9959 19.0379 12.9959C22.9931 14.7772 23.8346 17.1536 23.9998 22.7171H8.30407Z"
      fill="#D9D9D9"
    />
  </svg>
);

const USPs: USPType[] = [
  {
    icon: profitIcon,
    title: "Sort by Profit",
    description: (
      <div className="w-76 mobile:w-100">
        Instantly spot bronze, silver or potential meta evolution cards you can
        sell for <span className="italic font-semibold">easy profit</span>
      </div>
    ),
  },
  {
    icon: coinIcon,
    title: "Club Value",
    description: (
      <div className="w-76 mobile:w-100">
        See your <span className="italic font-semibold">club value</span>,{" "}
        <span className="italic font-semibold">SBC fodder</span>
        {} and your total{" "}
        <span className="italic font-semibold">potential coins</span>
      </div>
    ),
  },

  {
    icon: playerIcon,
    title: "Player Overview",
    description: (
      <div className="w-76 mobile:w-100">
        Get an easy overview of your{" "}
        <span className="italic font-semibold">tradeables</span>,{" "}
        <span className="italic font-semibold">duplicates</span>,{" "}
        <span className="italic font-semibold">special cards</span> and much
        more
      </div>
    ),
  },
];

export const MyPlayersLandingPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const from = (location.state as LocationState)?.from || "/my-club";
  return (
    <BaseLandingPage
      heroTitle="EA FC 25 My Club Overview"
      pageTitle="Unlock the full potential of your club"
      navigateBack={from}
      ctaTitle="Subscribe Now"
      USPs={USPs}
      onHandleCTA={() => {
        navigate("/subscription");
      }}
    >
      <img
        src={
          import.meta.env.VITE_APP_ASSETS_BASE_URL +
          "/fc25/my-club/my-players/subscription-hook.png"
        }
        className="absolute top-16 large-desktop:top-8 left-128 hidden touch-device:block max-w-112 touch-device:max-w-144 large-desktop:max-w-200"
      />
    </BaseLandingPage>
  );
};
